import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const TimeColumnWrapper = styled.div`
  grid-area: start-time;
  display: grid;
  align-self: center;
`;

export const Wrapper = styled.div`
  grid-column: 1;
  grid-row: 1;
  min-width: max-content;

  font-family: var(--ogm-font-family-2);
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  padding-right: 20px;
`;

export const fullTime = css`
  color: var(--ogm-text-body);
`;

export const InPlayTimeWrapper = styled.div`
  grid-column: 1;
  grid-row: 1;
  display: flex;
  align-items: center;
  min-width: max-content;
  padding-right: 20px;
`;

export const InPlayBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: var(--oc-secondary-red);
  color: var(--oc-text-white);

  min-width: 36px;
  height: 16px;
  padding: 0 4px;

  font-family: var(--oc-font-family);
  font-size: 10px;
  font-weight: 800;
  text-align: center;
  text-transform: uppercase;

  border-radius: 3px;
`;
